import { injectStyle } from "./../../utils/style";
import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import PullPanel from '../PullPanel';
import MDatePicker from './rmc-date-picker/DatePicker';
import dayjs from 'dayjs';
import { emptyFn } from '../../utils/helper';
import { i18n } from '../../common/locale';
injectStyle("components/DateTimePicker/style/DateTimePicker.css", "[data-duim-0-106-4~=\"dui-m-picker\"]{position:relative;overflow:hidden;height:180px;text-align:center;-webkit-box-flex:1;-webkit-flex:1;flex:1;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;font-size:16px}[data-duim-0-106-4~=\"dui-m-picker-mask\"]{position:absolute;pointer-events:none;left:0;top:0;height:100%;margin:0 auto;width:100%;z-index:3;background-position:top,bottom;background-repeat:no-repeat;background-image:-webkit-gradient(linear,left top,left bottom,from(#fff),to(rgba(248,249,250,0))),-webkit-gradient(linear,left bottom,left top,from(#fff),to(rgba(248,249,250,0)));background-image:-webkit-linear-gradient(top,#fff,rgba(248,249,250,0)),-webkit-linear-gradient(bottom,#fff,rgba(248,249,250,0));background-image:linear-gradient(180deg,#fff,rgba(248,249,250,0)),linear-gradient(0deg,#fff,rgba(248,249,250,0))}[data-duim-0-106-4~=\"dui-m-picker-content\"]{position:absolute;left:0;top:0;z-index:1}[data-duim-0-106-4~=\"dui-m-picker-content-container\"]{height:36px;position:relative;-webkit-align-self:flex-start;align-self:flex-start}[data-duim-0-106-4~=\"dui-m-picker-content-placeholder\"]{visibility:hidden}[data-duim-0-106-4~=\"dui-m-picker-indicator\"]{height:36px;line-height:36px;pointer-events:none;font-weight:500;color:#175ceb}[data-duim-0-106-4~=\"dui-m-picker-item\"]{white-space:nowrap;-webkit-box-sizing:border-box;box-sizing:border-box;height:36px;line-height:36px;color:rgba(0,0,0,.4);padding:0;overflow:visible}[data-duim-0-106-4~=\"dui-m-picker-item-selected\"]{color:#175ceb;font-weight:500}[data-duim-0-106-4~=\"dui-m-date-picker\"]{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;padding:7px 0;width:100%}[data-duim-0-106-4~=\"dui-m-datetimepicker\"]{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;min-width:200px}[data-duim-0-106-4~=\"dui-m-datetimepicker\"],[data-duim-0-106-4~=\"dui-m-datetimepicker-panel-content\"]{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}[data-duim-0-106-4~=\"dui-m-datetimepicker-panel-content\"]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-align:center;-webkit-align-items:center;align-items:center}[data-duim-0-106-4~=\"dui-m-datetimepicker\"] *{-webkit-box-sizing:border-box;box-sizing:border-box}[data-duim-0-106-4~=\"dui-m-datetimepicker-now-button\"]{margin:6px 0 12px;padding:12px;line-height:24px;text-align:center;font-size:18px;color:var(--text-link,#175ceb)}[data-duim-0-106-4~=\"dui-m-datetimepicker-now-button\"]:active{opacity:.6}[data-duim-0-106-4~=\"dui-m-datetimepicker-indicator\"]{position:absolute;left:0;right:0;pointer-events:none;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);height:36px;background:rgba(30,111,255,.08);border-radius:4px}[data-duim-0-106-4~=\"dui-m-datetimepicker-datetime\"]{min-width:240px}[data-duim-0-106-4~=\"dui-m-datetimepicker-datetime\"] [data-duim-0-106-4~=\"dui-m-picker-year\"]{-webkit-box-flex:1.359375;-webkit-flex:1.359375;flex:1.359375}[data-duim-0-106-4~=\"dui-m-datetimepicker-no-animation\"] [data-duim-0-106-4~=\"dui-m-picker-content\"]{-webkit-transition:none!important;transition:none!important}");
var noLocale = {
    year: '',
    month: '',
    day: '',
    hour: ' ',
    minute: '',
    am: '',
    pm: ''
};
var DateTimePicker = (function (_super) {
    __extends(DateTimePicker, _super);
    function DateTimePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentValue: _this.getDefaultValue(),
            disableScrollTransition: true,
        };
        _this.mobileDatePickerContainerRef = React.createRef();
        _this.handlePickerChange = function (date) {
            var value = dayjs(date);
            _this.handleChange(value, 'scroll');
        };
        _this.handleNow = function () {
            _this.handleChange(dayjs(), 'nowButton');
        };
        _this.handleOk = function () {
            _this.props.onOk(_this.getCurrentValue());
        };
        _this.enableScrollTransition = function () {
            _this.setState({ disableScrollTransition: false });
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, visible = _a.visible, zIndex = _a.zIndex, onCancel = _a.onCancel, embedded = _a.embedded, nowButtonText = _a.nowButtonText, onClose = _a.onClose, cancelText = _a.cancelText;
            if (embedded) {
                return _this.renderContent(classNames);
            }
            return (h(PullPanel, { visible: visible, onOk: _this.handleOk, onCancel: onCancel, onClose: onClose, okText: i18n('done'), cancelText: cancelText, title: "", zIndex: zIndex, headerSize: "small", className: classNames(prefixCls + "-panel"), contentClassName: classNames(prefixCls + "-panel-content"), showHeaderBorder: false, destroyOnClose: true, pullHeaderOnly: true },
                _this.renderContent(classNames),
                nowButtonText && h("div", { className: classNames(prefixCls + "-now-button"), onClick: _this.handleNow }, nowButtonText)));
        };
        return _this;
    }
    DateTimePicker.prototype.getCurrentValue = function () {
        return this.props.value || this.state.currentValue;
    };
    DateTimePicker.prototype.getDefaultValue = function () {
        return this.props.defaultValue || dayjs();
    };
    DateTimePicker.prototype.handleChange = function (value, source) {
        this.setState({ currentValue: value });
        this.props.onChange(value, { source: source });
    };
    DateTimePicker.prototype.preventTouchMove = function () {
        var dom = this.mobileDatePickerContainerRef.current;
        if (!dom || dom.__dui_touch_move_stopped__) {
            return;
        }
        dom.addEventListener('touchmove', function (e) {
            e.stopPropagation();
            e.cancelable && e.preventDefault();
        }, { passive: false });
        dom.__dui_touch_move_stopped__ = true;
    };
    DateTimePicker.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.setState({ currentValue: this.getDefaultValue(), disableScrollTransition: true });
            this.preventTouchMove();
        }
    };
    DateTimePicker.prototype.componentDidMount = function () {
        this.preventTouchMove();
    };
    DateTimePicker.prototype.renderContent = function (classNames) {
        var _a;
        var _b = this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, mode = _b.mode, minDate = _b.minDate, maxDate = _b.maxDate, itemStyle = _b.itemStyle, maxHour = _b.maxHour, maxMinute = _b.maxMinute, minHour = _b.minHour, minMinute = _b.minMinute, minuteStep = _b.minuteStep;
        var disableScrollTransition = this.state.disableScrollTransition;
        var classes = classNames(prefixCls, className, prefixCls + "-" + mode, (_a = {},
            _a[prefixCls + "-no-animation"] = disableScrollTransition,
            _a));
        var indicatorClasses = classNames(prefixCls + "-indicator");
        var value = this.getCurrentValue();
        return (h("div", { className: classes, ref: this.mobileDatePickerContainerRef, style: style, onTouchStart: this.enableScrollTransition },
            h(MDatePicker, { prefixCls: "dui-m-date-picker", pickerPrefixCls: "dui-m-picker", locale: noLocale, date: value.toDate(), onDateChange: this.handlePickerChange, mode: mode, minDate: minDate.toDate(), maxDate: maxDate.toDate(), itemStyle: itemStyle, maxHour: maxHour, maxMinute: maxMinute, minHour: minHour, minMinute: minMinute, minuteStep: minuteStep }),
            h("div", { className: indicatorClasses })));
    };
    DateTimePicker.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return DateTimePicker;
}(React.Component));
export default DateTimePicker;
DateTimePicker.defaultProps = {
    prefixCls: 'dui-m-datetimepicker',
    mode: 'date',
    minDate: dayjs('1900-01-01T00:00:00'),
    maxDate: dayjs('2100-12-31T23:59:59'),
    onChange: emptyFn,
    onOk: emptyFn,
    onCancel: emptyFn,
    minHour: 0,
    maxHour: 23,
    minMinute: 0,
    maxMinute: 59,
    minuteStep: 1,
    cancelText: i18n('cancel'),
};
